import React, { useEffect, useState } from "react";
import api, { inr } from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);

  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)); }, []);

  return (
    <div className="fade-in" data-testid="admin-customers">
      <h1 className="font-serif text-4xl text-forest mb-1">Customers</h1>
      <p className="text-muted-foreground text-sm mb-8">{customers.length} customers</p>

      {customers.length === 0 ? <p className="text-muted-foreground">No customers yet.</p> : (
        <div className="bg-white border border-border rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-forest text-cream text-left"><tr>
              <th className="p-4">Name</th><th className="p-4">Phone</th><th className="p-4">Email</th><th className="p-4">Orders</th><th className="p-4">Total Spent</th><th className="p-4">Last Order</th>
            </tr></thead>
            <tbody>
              {customers.map((c, i) => (
                <tr key={i} className="border-b border-border" data-testid={`customer-row-${i}`}>
                  <td className="p-4 text-forest font-medium">{c.name}</td>
                  <td className="p-4 text-muted-foreground">{c.phone}</td>
                  <td className="p-4 text-muted-foreground">{c.email || "—"}</td>
                  <td className="p-4">{c.orders}</td>
                  <td className="p-4 text-forest">{inr(c.total_spent)}</td>
                  <td className="p-4 text-muted-foreground text-xs">{new Date(c.last_order).toLocaleDateString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
